import React from 'react';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';

import ProgressStepper from 'app/shared/components/Stepper/ProgressStepper';
import Step from 'app/shared/components/Stepper/Step';

import {
    StyledProgressStepperContainer,
    StyledProgressStepperContent,
} from './StyledComponents';

const propTypes = {
    currentStepKey: PropTypes.string.isRequired,
    isOrdered: PropTypes.bool,
    onGoToStep: PropTypes.func.isRequired,
    progressSteps: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })),
    steps: PropTypes.arrayOf(PropTypes.shape({
        stepKey: PropTypes.string.isRequired,
        wizardBodyTemplate: PropTypes.func,
        progressStepKey: PropTypes.string,
        nextStepKey: PropTypes.string, // Custom order
        previousStepKey: PropTypes.string, // Custom order
    })).isRequired,
    breadCrumb: PropTypes.node,
    propertyId: PropTypes.string,
};

const defaultProps = {
    isOrdered: true,
    progressSteps: [],
    breadCrumb: null,
    propertyId: null,
};

const PageWizard = ({
    currentStepKey,
    isOrdered,
    onGoToStep,
    progressSteps,
    steps,
    breadCrumb,
    propertyId,
}) => {
    const currentIndex = findIndex(steps, step => step.stepKey === currentStepKey);
    const currentStep = steps[currentIndex];
    const currentProgressStepKey = currentStep && currentStep.progressStepKey;
    const progressStepIndex = findIndex(progressSteps, progressStep => progressStep.key === currentProgressStepKey);

    const renderCurrentComponent = () => {
        const CurrentWizardBodyTemplate = currentStep && currentStep.wizardBodyTemplate;
        let { nextStepKey } = currentStep;
        let { previousStepKey } = currentStep;
        if (!CurrentWizardBodyTemplate) {
            return <div>Page not found</div>;
        }
        if (isOrdered) {
            const nextStep = steps[currentIndex + 1];
            nextStepKey = nextStep && nextStep.stepKey;
            const previousStep = steps[currentIndex - 1];
            previousStepKey = previousStep && previousStep.stepKey;
        }

        return (
            <CurrentWizardBodyTemplate
                onGoToStep={onGoToStep}
                onGoToNextStep={nextStepKey ? () => onGoToStep(nextStepKey) : null}
                onGoToPrevStep={previousStepKey ? () => onGoToStep(previousStepKey) : null}
                hasPrevStep={!!previousStepKey}
                hasNextStep={!!nextStepKey}
                propertyId={propertyId}
            />
        );
    };

    return (
        <>
            {progressSteps.length && !currentStep.hideProgressStepper && (
                <StyledProgressStepperContainer>
                    <StyledProgressStepperContent>
                        <ProgressStepper activeIndex={progressStepIndex}>
                            {progressSteps.map(progressStep => (
                                <Step
                                    key={progressStep.key}
                                    label={progressStep.label}
                                />
                            ))}
                        </ProgressStepper>
                    </StyledProgressStepperContent>
                </StyledProgressStepperContainer>
            )}
            {breadCrumb}
            {renderCurrentComponent()}
        </>
    );
};

PageWizard.propTypes = propTypes;
PageWizard.defaultProps = defaultProps;

export default PageWizard;
